"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _uuid = require("uuid");

var _reactTimeout = _interopRequireDefault(require("react-timeout"));

var _styles = require("./styles");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A simple component for displaying an accordion section
 */
const StyledAccordionSection = ({
  open,
  title,
  children,
  onOpen,
  onClose,
  onToggle,
  toggleOpened,
  setTimeout,
  requestAnimationFrame,
  cancelAnimationFrame,
  clearImmediate,
  setImmediate,
  setInterval,
  clearTimeout,
  clearInterval,
  ...otherProps
}) => {
  open = !!open;
  const ref = (0, _react.useRef)(null);
  const [maxHeight, setMaxHeight] = (0, _react.useState)(0);

  const toggle = () => {
    if (open) {
      setMaxHeight(`${ref.current.offsetHeight}px`);
      setTimeout(() => {
        setMaxHeight(0);
      }, 1);

      if (onClose) {
        onClose();
      }
    } else {
      setMaxHeight(`${ref.current.offsetHeight}px`);
      setTimeout(() => {
        setMaxHeight(`none`);
      }, 250);

      if (onOpen) {
        onOpen();
      }
    }

    if (onToggle) {
      onToggle();
    }

    toggleOpened({
      open: !open
    });
  };

  const onKeyDown = e => {
    if (e.key === 'Enter' || e.key === ' ') {
      toggle();
    }
  };

  const sectionId = (0, _uuid.v4)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.AccordionSection, { ...otherProps,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.AccordionHeader, {
      id: `accordion-heading-${sectionId}`,
      "aria-expanded": open,
      "aria-controls": `accordion-heading-${sectionId}-content`,
      onClick: toggle,
      role: "button",
      tabIndex: "0",
      onKeyDown: onKeyDown,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.AccordionTitle, {
        className: "accordion__title",
        children: title
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.ToggleIcon, {
        className: "accordion__icon",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.IconLine, {
          className: "accordion__icon__symbol-line accordion__icon__symbol-line--one"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.IconLine, {
          open: open,
          className: "accordion__icon__symbol-line accordion__icon__symbol-line--two"
        })]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.AccordionContent, {
      className: "accordion__content",
      id: `accordion-heading-${sectionId}-content`,
      role: "region",
      "aria-labelledby": `accordion-heading-${sectionId}`,
      open: open,
      maxHeight: maxHeight,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.AccordionContentInner, {
        className: "accordion__content__inner",
        ref: ref,
        children: children
      })
    })]
  });
};

StyledAccordionSection.propTypes = {
  open: _propTypes.default.bool,
  title: _propTypes.default.string,
  onOpen: _propTypes.default.func,
  onClose: _propTypes.default.func,
  onToggle: _propTypes.default.func
};
StyledAccordionSection.defaultProps = {
  open: false
};

var _default = (0, _reactTimeout.default)(StyledAccordionSection);

exports.default = _default;